export default __webpack_public_path__ + "static/media/5.69705e9e.png";